import { useCallback, useEffect, useState } from "react";
import { fetchInfoScreenEvents } from "@/lib/infoScreenEventsApi";
import type { InfoScreenEventsPayload } from "@/types/infoScreenEvents";

const POLL_MS = 5 * 60 * 1000;

export function useInfoScreenEvents(displayCode: string, options: { enabled: boolean }) {
  const [data, setData] = useState<InfoScreenEventsPayload | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!options.enabled) return;
    setLoading(true);
    setError(null);
    try {
      const payload = await fetchInfoScreenEvents(displayCode);
      setData(payload);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Veranstaltungen konnten nicht geladen werden");
      setData({
        enabled: false,
        city_label: "Frankfurt am Main",
        events: [],
        rotation_seconds: 10,
        modules: [],
      });
    } finally {
      setLoading(false);
    }
  }, [displayCode, options.enabled]);

  useEffect(() => {
    void load();
  }, [load]);

  useEffect(() => {
    if (!options.enabled) return;
    const timer = window.setInterval(() => void load(), POLL_MS);
    return () => window.clearInterval(timer);
  }, [load, options.enabled]);

  return { data, loading, error, reload: load };
}
